import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { useTranslation } from "../../common/models/Dictionary";
import Copy from "../icons/copy";
import copy from "copy-to-clipboard";
import NotificationContext, { ToastType } from "../../Contexts/Notification";
import earn from "../../assets/images/earn.png";
import { texts } from "../LoginComponent/texts";
import classes from "Pages/Ambassador/Ambassador.module.css"
import signUpImage from "assets/images/SignupNew.png"
import inviteUser from "assets/images/inviteUser.svg"
import Gift from "assets/images/Gift.svg"
import whatsApp from "assets/images/whatsapp.svg"
import twitter from "assets/images/twitter.png"
import facebook from "assets/images/facebook.svg"
import XTwitter from "assets/images/x-twitter.svg"
import xTwitterBlue from "assets/images/x-twitterBlue.svg"
import AppContext from "Contexts/AppContext";
import UserContext from "Contexts/User";
import Layer from "assets/images/Layer.png"
import GroupNew from "assets/images/GroupNew.png"
import ShareBlue from "assets/svg/ShareBlue.svg"
import ShareGold from "assets/svg/ShareGold.svg"
import ShareNew from "assets/images/ShareNew.png"
import VBG from "assets/images/VBG.png"
import VBGM from "assets/images/VBGM.png"
import FirstImage from "../../assets/PoolminingImage/image1.avif";
import SecondImage from "../../assets/PoolminingImage/image2.avif";
import ThirdImage from "../../assets/PoolminingImage/image3.avif";
import FourthImage from "../../assets/PoolminingImage/image4.avif";
import FifthImage from "../../assets/PoolminingImage/image5.avif";
import SixthImage from "../../assets/PoolminingImage/image6.avif";
import SeventhImage from "../../assets/PoolminingImage/image7.avif";
import EighthImage from "../../assets/PoolminingImage/image8.avif";
import NinthImage from "../../assets/PoolminingImage/image9.avif";

// Golden Title with gradient
const GoldenTitle = styled.h1`
  font-family: 'Lilita One', sans-serif;
  font-size: clamp(2.5rem, 5vw, 3.5rem);
  font-weight: 900;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 4px;
  margin: 2rem 0 1rem;
  background: linear-gradient(180deg, #FFD700 0%, #FFA500 50%, #FF8C00 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 4px 8px rgba(255, 215, 0, 0.3);
  position: relative;
`;

// Subtitle text
const SubtitleText = styled.p`
  font-size: clamp(0.95rem, 2.5vw, 1.1rem);
  color: #ffffff;
  text-align: center;
  margin: 0.5rem auto;
  max-width: 700px;
  font-weight: 400;
  letter-spacing: 0.5px;
  line-height: 1.6;
`;

// Octagonal Step Card (matching reference image)
const HexagonCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0.5rem;
  align-self: flex-start;
  
  .hexagon-wrapper {
    position: relative;
    width: clamp(80px, 14vw, 110px);
    height: clamp(80px, 14vw, 110px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .hexagon {
    position: relative;
    width: 100%;
    height: 100%;
    transition: all 0.3s ease;
    
    &::before {
      content: '';
      position: absolute;
      inset: 0;
      background: linear-gradient(135deg, #B8860B 0%, #DAA520 50%, #B8860B 100%);
      clip-path: polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);
    }
    
    &::after {
      content: '';
      position: absolute;
      inset: 2.5px;
      background: rgba(30, 20, 60, 0.98);
      clip-path: polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);
    }
  }
  
  .hexagon-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    width: clamp(45px, 8vw, 60px);
    height: clamp(45px, 8vw, 60px);
    
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      filter: drop-shadow(0 2px 6px rgba(255, 215, 0, 0.4));
    }
  }
  
  &:hover .hexagon {
    transform: scale(1.05);
    
    &::before {
      background: linear-gradient(135deg, #FFD700 0%, #FFA500 50%, #FFD700 100%);
      filter: drop-shadow(0 0 10px rgba(255, 215, 0, 0.6));
    }
  }
  
  &:hover .hexagon-content img {
    filter: drop-shadow(0 4px 10px rgba(255, 215, 0, 0.7));
    transform: scale(1.1);
  }
  
  p {
    margin-top: 0.75rem;
    font-size: clamp(0.7rem, 1.8vw, 0.85rem);
    font-weight: 700;
    color: #FFFFFF;
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
    max-width: 110px;
    line-height: 1.2;
    min-height: 2.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  @media (max-width: 768px) {
    margin: 0.5rem 0;
    align-self: flex-start;
    
    .hexagon-wrapper {
      width: 70px;
      height: 70px;
    }
    
    .hexagon-content {
      width: 40px;
      height: 40px;
    }
    
    p {
      font-size: 0.6rem;
      max-width: 80px;
      margin-top: 0.5rem;
      min-height: 2rem;
      line-height: 1.1;
    }
  }
`;

// Connector Arrow
const ConnectorArrow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0.5rem;
  align-self: flex-start;
  margin-top: calc(clamp(80px, 14vw, 110px) / 2 - 2px);
  
  .arrow-line {
    width: 60px;
    height: 4px;
    background: linear-gradient(90deg, #D4AF37 0%, #FFD700 100%);
    box-shadow: 0 0 10px rgba(212, 175, 55, 0.5);
    position: relative;
    
    &::after {
      content: '';
      position: absolute;
      right: -8px;
      top: 50%;
      transform: translateY(-50%);
      width: 0;
      height: 0;
      border-left: 8px solid #FFD700;
      border-top: 6px solid transparent;
      border-bottom: 6px solid transparent;
    }
  }
  
  
  @media (max-width: 768px) {
    display: none;
  }
`;

// Golden gradient text for main CTA
const GoldenGradientText = styled.h2`
  font-family: 'Lilita One', sans-serif;
  font-size: clamp(1.5rem, 4vw, 2rem);
  font-weight: 900;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 3px;
  margin: 3rem 0 2rem;
  background: linear-gradient(180deg, #FFD700 0%, #FFA500 50%, #FF8C00 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 4px 8px rgba(255, 215, 0, 0.3);
`;

// Gaming style button with purple and gold
export const GamingButton = styled.button`
  position: relative;
  padding: 16px 45px;
  font-size: 1.2rem;
  font-weight: 900;
  font-family: 'Lilita One', sans-serif;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: #FFD700;
  background: linear-gradient(135deg, rgba(75, 0, 130, 0.8) 0%, rgba(138, 43, 226, 0.8) 100%);
  border: 3px solid #D4AF37;
  border-radius: 0;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 0 20px rgba(212, 175, 55, 0.4),
              inset 0 0 20px rgba(138, 43, 226, 0.2);
  clip-path: polygon(15px 0, 100% 0, calc(100% - 15px) 100%, 0 100%);
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 215, 0, 0.3), transparent);
    transition: left 0.5s ease;
  }
  
  &:hover {
    border-color: #FFD700;
    box-shadow: 0 0 30px rgba(255, 215, 0, 0.6),
                inset 0 0 30px rgba(138, 43, 226, 0.3);
    transform: translateY(-2px);
    
    &::before {
      left: 100%;
    }
  }
  
  &:active {
    transform: translateY(0);
  }
  
  span {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: center;
  }
  
  img {
    width: 20px;
    height: 20px;
    filter: drop-shadow(0 0 5px rgba(255, 215, 0, 0.8));
  }
`;

// Share popup with gaming style
const SharePopup = styled.div`
  position: absolute;
  top: calc(100% + 15px);
  left: 50%;
  transform: translateX(-50%);
  padding: 20px 25px;
  background: linear-gradient(135deg, rgba(20, 0, 40, 0.95) 0%, rgba(40, 0, 60, 0.95) 100%);
  border: 2px solid #D4AF37;
  box-shadow: 0 10px 40px rgba(212, 175, 55, 0.4),
              inset 0 0 20px rgba(138, 43, 226, 0.2);
  display: flex;
  gap: 15px;
  align-items: center;
  z-index: 1000;
  clip-path: polygon(10px 0, 100% 0, calc(100% - 10px) 100%, 0 100%);
  
  &::before {
    content: '';
    position: absolute;
    top: -12px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    border-bottom: 12px solid #D4AF37;
  }
  
  span, a {
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    
    &:hover {
      transform: scale(1.15);
      filter: drop-shadow(0 0 10px rgba(255, 215, 0, 0.8));
    }
  }
  
  .material-symbols-outlined {
    color: #FFD700;
    font-size: 28px;
  }
  
  img {
    width: 28px;
    height: 28px;
  }
`;

// Section title with golden style
const SectionTitle = styled.h3`
  font-family: 'Lilita One', sans-serif;
  font-size: clamp(1.5rem, 4vw, 2rem);
  font-weight: 800;
  color: #FFD700;
  text-align: left;
  text-transform: uppercase;
  letter-spacing: 2px;
  margin: 2rem 0 1.5rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
`;

// Feature list with bullets
const FeatureList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 1.5rem 0;
  counter-reset: feature-counter;
  
  li {
    position: relative;
    padding: 1rem 1rem 1rem 3rem;
    margin: 1rem 0;
    color: #fff;
    font-size: 1rem;
    line-height: 1.7;
    transition: all 0.3s ease;
    counter-increment: feature-counter;
    
    &::before {
      content: counter(feature-counter) '.';
      position: absolute;
      left: 0.5rem;
      top: 1rem;
      font-size: 1.4rem;
      font-weight: 900;
      color: #fff;;
    }
    
    &:hover {
      transform: translateX(5px);
      color: #FFD700;
    }
  }
`;

// Highlight text
const HighlightText = styled.span`
  color: #FFD700;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  text-shadow: 0 0 10px rgba(255, 215, 0, 0.5);
`;

// Glowing Image with neon shadow
const GlowingImage = styled.img`
  filter: drop-shadow(0 0 8px rgba(138, 43, 226, 0.6))
          drop-shadow(0 0 15px rgba(147, 51, 234, 0.4));
  animation: glowPulse 3s ease-in-out infinite;
  border-radius: 10px;
  
  @keyframes glowPulse {
    0%, 100% {
      filter: drop-shadow(0 0 8px rgba(138, 43, 226, 0.6))
              drop-shadow(0 0 15px rgba(147, 51, 234, 0.4));
    }
    50% {
      filter: drop-shadow(0 0 12px rgba(138, 43, 226, 0.7))
              drop-shadow(0 0 20px rgba(147, 51, 234, 0.5));
    }
  }
`;

// Category Grid Container
const CategoryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  max-width: 1000px;
  margin: 3rem auto;
  padding: 0 1rem;
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
    margin: 3rem auto 4rem;
    max-width: 500px;
    
    /* Center the last item on mobile if it's alone */
    & > :nth-child(9):last-child {
      grid-column: 1 / -1;
      max-width: 50%;
      margin: 0 auto;
    }
  }
`;

// Category Card
const CategoryCard = styled.div`
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  border: 2px solid #D4AF37;
  box-shadow: 0 4px 15px rgba(212, 175, 55, 0.3);
  transition: all 0.3s ease;
  background: rgba(20, 10, 40, 0.6);
  aspect-ratio: 1;
  
  &:hover {
    transform: translateY(-5px);
    border-color: #FFD700;
    box-shadow: 0 8px 25px rgba(255, 215, 0, 0.5);
  }
  
  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }
`;

type ShareAndEarnProps = {
  url: string;
  text: string;
  shareText: string;
};

const Share = ({ url, text, shareText }: ShareAndEarnProps) => {
  const translate = useTranslation();
  const { showToast } = useContext(NotificationContext);
  const [showShare, setShowShare] = useState(false);
  const { user } = useContext(UserContext);
  const { setLogin } = useContext(AppContext);
  const pageUrl = window.location.pathname;

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const imageSources = [ShareGold, ShareBlue];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % imageSources.length);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={`gr_bg py-4 ${pageUrl.includes("/Ambassador") ? "px-0" : "px-3"}`}>
      <div className="content-pages">
        <div className="p-0">
          {/* Title Section */}
          <div className="pt-3">
            <GoldenTitle>ANYONE CAN LEAD, ENGAGE, AND EARN.</GoldenTitle>
          </div>

          {/* Subtitle */}
          <div className="pt-4 px-3">
            <SubtitleText>
              Whether you’ve got 100 followers or 1,000,000, this is your chance to own your space, grow your group, and earn while doing it. with  Create your own Parliament, invite your people, and make every voice count including yours.
            </SubtitleText>
          </div>

          {/* Steps Section with Hexagons */}
          <div style={{ paddingTop: '1rem' }}>
            {/* Category Images Grid */}
            <CategoryGrid>
              <CategoryCard>
                <img src={FirstImage} alt="Sports Clubs & Fan Groups" />
              </CategoryCard>
              <CategoryCard>
                <img src={SecondImage} alt="Influencers & Creators" />
              </CategoryCard>
              <CategoryCard>
                <img src={ThirdImage} alt="Streamers" />
              </CategoryCard>
              <CategoryCard>
                <img src={FourthImage} alt="Student Councils" />
              </CategoryCard>
              <CategoryCard>
                <img src={FifthImage} alt="Political Candidates" />
              </CategoryCard>
              <CategoryCard>
                <img src={SixthImage} alt="Small Business Owners & Startups" />
              </CategoryCard>
              <CategoryCard>
                <img src={SeventhImage} alt="Creative Artists" />
              </CategoryCard>
              <CategoryCard>
                <img src={EighthImage} alt="Anyone With A Group Can Lead" />
              </CategoryCard>
              <CategoryCard>
                <img src={NinthImage} alt="Families" />
              </CategoryCard>
            </CategoryGrid>

            {/* Main CTA */}
            <div className="text-center">
              <GoldenGradientText>READY TO TURN YOUR COMMUNITY INTO A MOVEMENT?</GoldenGradientText>
            </div>


            {/* How It Works Section */}
            <div
              className="d-flex justify-content-center align-items-center mt-5"
              style={{ maxWidth: '900px', margin: '3rem auto 0' }}
            >
              <div className="w-100 px-3">
                <SectionTitle>How does it work?</SectionTitle>
                <FeatureList>
                  <li>
                    Create Your Parliament It takes just a few clicks to launch your own interactive space.
                  </li>
                  <li>
                    Invite Your Crowd Bring in your followers, friends, team, or students anyone can join and vote.
                  </li>
                  <li>
                    Run Polls, Games & Challenges Let them vote on ideas, content, predictions, or anything you want feedback on.
                  </li>
                  <li>
                    Grow, Learn, and Earn. See your influence in real-time. The more engagement you drive, the more rewards you and your voters unlock.
                  </li>
                </FeatureList>
              </div>
            </div>

            {/* Bottom CTA */}
            <div className="d-flex justify-content-center mt-4 mb-5" style={{ position: 'relative' }}>
              <GamingButton
                onClick={() => {
                  if (!user?.uid) {
                    setLogin(true);
                  } else {
                    setShowShare((prev) => !prev);
                  }
                }}
              >
                <span>
                  SHARE NOW TO START EARNING!
                  <img src={imageSources[currentImageIndex]} alt="Share" />
                </span>
              </GamingButton>

              {showShare && (
                <SharePopup>
                  <span
                    className="material-symbols-outlined"
                    onClick={() => {
                      copy(url);
                      showToast(
                        'Your referral link is copied to the clipboard.',
                        ToastType.SUCCESS
                      );
                    }}
                  >
                    content_copy
                  </span>
                  <a
                    href={`https://api.whatsapp.com/send/?phone&text=${`${shareText} ${url}`.replace(" ", "+")}&app_absent=0`}
                    target="_blank"
                    onClick={() => setShowShare(false)}
                  >
                    <img src={whatsApp} alt="WhatsApp" />
                  </a>
                  <a
                    href={`https://twitter.com/intent/tweet?url=${url}?check_suite_focus=true&text=${shareText}`}
                    target="_blank"
                    onClick={() => setShowShare(false)}
                  >
                    <img src={xTwitterBlue} alt="Twitter" />
                  </a>
                  <a
                    href={`https://www.facebook.com/sharer/sharer.php?u=${url}&t=${shareText}`}
                    target="_blank"
                    onClick={() => setShowShare(false)}
                  >
                    <img src={facebook} alt="Facebook" />
                  </a>
                </SharePopup>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Share;
